/**
 * @generated SignedSource<<91a5bca76de0352e7ee00fb8435575fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ChecklistItemStatus = "COMPLETE" | "NA" | "NOT_STARTED" | "WARNING";
import { FragmentRefs } from "relay-runtime";
export type admin_checklist$data = {
  readonly checklist: {
    readonly rooms: {
      readonly reason: string;
      readonly status: ChecklistItemStatus;
    };
    readonly seating: {
      readonly reason: string;
      readonly status: ChecklistItemStatus;
    };
    readonly staff: {
      readonly reason: string;
      readonly status: ChecklistItemStatus;
    };
    readonly timing: {
      readonly reason: string;
      readonly status: ChecklistItemStatus;
    };
    readonly versions: {
      readonly reason: string;
      readonly status: ChecklistItemStatus;
    };
  };
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"accommodations_all" | "admin_versionInfo" | "allocateVersions" | "assignStaff" | "roomsIndex" | "studentDnd" | "versionTiming">;
  readonly " $fragmentType": "admin_checklist";
};
export type admin_checklist$key = {
  readonly " $data"?: admin_checklist$data;
  readonly " $fragmentSpreads": FragmentRefs<"admin_checklist">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reason",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "admin_checklist",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "admin_versionInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "accommodations_all"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "versionTiming"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "allocateVersions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "roomsIndex"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "assignStaff"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "studentDnd"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExamChecklist",
      "kind": "LinkedField",
      "name": "checklist",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExamChecklistSection",
          "kind": "LinkedField",
          "name": "rooms",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ExamChecklistSection",
          "kind": "LinkedField",
          "name": "timing",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ExamChecklistSection",
          "kind": "LinkedField",
          "name": "staff",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ExamChecklistSection",
          "kind": "LinkedField",
          "name": "seating",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ExamChecklistSection",
          "kind": "LinkedField",
          "name": "versions",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Exam",
  "abstractKey": null
};
})();

(node as any).hash = "197930e466aaf7016312f1b9b81a9efa";

export default node;
